import type { SpinnerProps } from '@chakra-ui/react';
import { Box, Center, Spinner as ChakraSpinner, useColorModeValue } from '@chakra-ui/react';
import type { FC } from 'react';

export const Spinner: FC<SpinnerProps> = props => (
  <ChakraSpinner
    thickness="4px"
    speed="0.65s"
    emptyColor={useColorModeValue(
      'neutral.stroke.light_theme', // light mode
      'neutral.stroke.light' // dark mode
    )}
    color={useColorModeValue(
      'neutral.stroke.light', // dark mode
      'neutral.stroke.light_theme' // light mode
    )}
    size="xl"
    {...props}
  />
);

export const SplashScreen: FC = () => {
  const bgColor = useColorModeValue(
    'rgba(245, 245, 245, 0.7)', // light mode - neutral.surface_light_theme with opacity
    'rgba(6, 6, 6, 0.7)' // dark mode - neutral.surface with opacity
  );

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg={bgColor}
      backdropFilter="blur(4px)"
      zIndex={9999}
    >
      <Center height="100vh">
        <Spinner />
      </Center>
    </Box>
  );
};

export const LoadingLayer: FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bg={useColorModeValue('rgba(230, 226, 226, 0.7)', 'rgba(24, 22, 22, 0.5)')}
      zIndex="2"
    >
      <Spinner size="md" />
    </Box>
  );
};
